export class EscrituraModel{

	constructor(		
        public id:MchInformacionEscrituraId,
		public cantidadCompradores:number,
		public vdescripcion:string,
        public nvalor:number,
        public vobservacion:string,
        public ncostos:number,
        public ndocumento:number,
        public ndocumentocostos:number,
        public nvalida:number,
        public vusuario:string,
        public dfecsist:Date,
        public defTiposEscritura:DefTiposEscritura
        ){}        
}
     
export class EscrituraModelEditar{

	constructor(		
        public id:MchInformacionEscrituraId,
		public cantidadCompradores:number,
		public vdescripcion:string,
        public nvalor:number,
        public vobservacion:string,
        public ncostos:number,
        public ndocumento:number,
        public ndocumentocostos:number,
        public nvalida:number,
        public vusuario:string,
        public dfecsist:Date,
        public defTiposEscritura:DefTiposEscritura,
        public nestado:string
        ){}        
}
     


export class MchInformacionEscrituraId{
	constructor(public vidEscritura:string, public cnumcont:string, public cprefijo:string){}
}

export class DefTiposEscritura{
	constructor(public ntipoescritura:string){}
}

export class MchCambioIdEscritura{
	constructor(public id:MchInformacionEscrituraId,  public vidEscrituraNuevo:string, public vobservacion:string){}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearEscritura/Escritura.model.ts